import {
    Button,
    CircularProgress,
    Grid,
    Pagination,
    Tooltip,
    Typography,
    Chip,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Switch,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import MiniDrawer from "../../Components/Drawer";
import BaseColor from "../../Config/Color";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getApiData } from "../../Apis/apiHelper";
import BaseSetting from "../../Apis/setting";
import { toast } from "react-toastify";
import CModal from "../../Components/CModal";
import { FontFamily } from "../../Config/theme";
import { Visibility } from "@mui/icons-material";
import { createSearchParams, useSearchParams } from "react-router-dom";
import _, { isArray, isEmpty } from "lodash";
import moment from "moment";
import CSelect from "../../Components/CSelect";
import { downloadOptions } from "../../Config/staticData";
import Papa from "papaparse";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const SubscriptionDetails = () => {
    const searchRef = useRef();

    // loader and modal
    const [pageLoad, setPageLoad] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [confirmationModal, setConfirmationModal] = useState(false);

    // CRUD
    const [subscriptionData, setSubscriptionData] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);

    // pagination
    const [pageNo, setPageNo] = useState(1);
    const [pagination, setPagination] = useState();
    const [dataLoader, setDataLoader] = useState(false);

    // sort and search
    const [searchVal, setSearchVal] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [rowChange, setRowChange] = useState(false);
    const [selectFileType, setSelectFileType] = useState("");

    // filters
    const [subscriptionPlan, setSubscriptionPlan] = useState(""); // Free, Gold, Premium
    const [subscriptionStatus, setSubscriptionStatus] = useState(""); // 1: active, 2: expired, 0: inactive/none
    const [isVerifiedFilter, setIsVerifiedFilter] = useState(""); // 1 yes, 0 no
    const [isWebsiteCreatedFilter, setIsWebsiteCreatedFilter] = useState(""); // 1 yes, 0 no
    const [startDate, setStartDate] = useState(""); // YYYY-MM-DD
    const [endDate, setEndDate] = useState(""); // YYYY-MM-DD
    const [country, setCountry] = useState("");
    const [stateName, setStateName] = useState("");
    const [city, setCity] = useState("");

    // get values from URL
    const isPage = searchParams.get("page");
    const page = isPage > 1 ? Number(isPage) : 1;
    const search = searchParams.has("search") ? searchParams.get("search") : "";
    const sortVal = searchParams.has("sort") ? searchParams.get("sort") : "";
    const sortByVal = searchParams.has("sort_by")
        ? searchParams.get("sort_by")
        : "";
    const downloadId = searchParams.has("download_id")
        ? searchParams.get("download_id")
        : [];

    const downloadIdArr = searchParams.has("download_id")
        ? searchParams
            .get("download_id")
            ?.split(",")
            .map((str) => parseInt(str, 10))
        : [];

    const [delIds, setDelIds] = useState(downloadIdArr);

    useEffect(() => {
        setHeaderParams(page, search, sortVal, sortByVal, downloadId);
        setTimeout(() => {
            setRowChange(true);
        }, 500);
    }, []);

    const dataGridRef = useRef();
    const getDataGridApi = (api) => {
        dataGridRef.current = api;
    };

    // auto-apply filters on change
    const didMountFilters = useRef(false);
    useEffect(() => {
        if (!didMountFilters.current) {
            didMountFilters.current = true;
            return;
        }
        const hasBothDates = !!startDate && !!endDate;

        // Only trigger fetch for date fields when both are provided,
        // otherwise ignore partial date values until both set or cleared
        if ((startDate && !endDate) || (!startDate && endDate)) return;

        setPageLoad(true);
        setHeaderParams(1, search, sortVal, sortByVal);
        allSubscriptionData(1, search, sortVal, sortByVal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscriptionPlan,
        subscriptionStatus,
        isVerifiedFilter,
        isWebsiteCreatedFilter,
        startDate,
        endDate,
        country,
        stateName,
        city,
    ]);

    // set data to URL params
    const setHeaderParams = (
        page,
        search = "",
        sort = "",
        sortBy = "",
        download_id = []
    ) => {
        const params = {
            page: page,
        };

        setPageNo(page);
        if (!_.isEmpty(search)) {
            setSearchVal(search?.trim());
        }
        if (!_.isEmpty(search)) {
            params.search = search;
        }
        if (!_.isEmpty(sort)) {
            params.sort = sort;
        }
        if (!_.isEmpty(sortBy)) {
            params.sort_by = sortBy;
        }
        setSearchParams(createSearchParams(params));
    };

    //close modal
    const handleClose = () => {
        setModalOpen(false);

        setSelectedUser(null);
    };

    // open edit modal
    const openEditModal = (data) => {
        setModalOpen(true);
        setSelectedUser(data);
    };

    // get subscription details list
    async function allSubscriptionData(page, search = "", sort = "", sortBy = "") {
        const payload = { page: page };

        if (!_.isEmpty(search)) payload.searchVal = search?.trim();
        if (!_.isEmpty(sort)) payload.sort = sort;
        if (!_.isEmpty(sortBy)) payload.sort_by = sortBy;

        const hasBothDates = !!startDate && !!endDate;
        const parseNullable = (val) => (val === "" || _.isNil(val) ? null : val);

        if (hasBothDates) {
            payload.start_date = moment(startDate).format("YYYY-MM-DD");
            payload.end_date = moment(endDate).format("YYYY-MM-DD");
            // Do not include other filters when date range is applied
        } else {
            // include non-date filters only when not in date-range mode
            payload.subscription_plan = parseNullable(subscriptionPlan);
            payload.subscription_status = parseNullable(subscriptionStatus);
            payload.is_verified = parseInt(isVerifiedFilter);
            payload.isWebsiteCreated = parseNullable(isWebsiteCreatedFilter);
            payload.country = parseNullable(country?.trim());
            payload.state = parseNullable(stateName?.trim());
            payload.city = parseNullable(city?.trim());
        }

        getApiData(BaseSetting.endpoint.getSubScriptionDetails, "post", payload)
            .then((result) => {
                if (result?.status) {
                    const response = result?.data || {};
                    const users = response?.users || [];

                    const transformed = users.map((u, idx) => {
                        const verifiedSource = (
                            u?.verified_status ??
                            u?.is_verified ??
                            u?.verified ??
                            ""
                        )
                            .toString()
                            .toLowerCase()
                            .trim();
                        const isVerified =
                            verifiedSource === "1" ||
                            verifiedSource === "true" ||
                            verifiedSource === "verified" ||
                            verifiedSource === "yes" ||
                            verifiedSource === "y";
                        // Treat approval status "approved" (and other truthy variants) as website created
                        const websiteApprovalSource = (
                            u?.approval_status ??
                            u?.approved_status ??
                            u?.website_status ??
                            u?.websiteCreated ??
                            ""
                        )
                            .toString()
                            .toLowerCase();
                        const isWebsiteCreated = ["approved", "1", "true", "created", "yes"].includes(websiteApprovalSource);
                        const subStatusString = (u?.subscription_status || "").toString().toLowerCase();
                        const planLabel = (u?.currentPlan || "-")
                            .toString()
                            .replace(/\s*plan$/i, "");

                        const startDate =
                            u?.subscription_start_date && u?.subscription_start_date !== "N/A"
                                ? u.subscription_start_date
                                : null;
                        const expiryDate =
                            u?.subscription_expiry_date && u?.subscription_expiry_date !== "N/A"
                                ? u.subscription_expiry_date
                                : null;

                        // Normalize business type to a readable string
                        let businessTypeValue = "-";
                        const rawBusinessType = !_.isNil(u?.business_type) ? u?.business_type : u?.type;
                        if (rawBusinessType && typeof rawBusinessType === "object") {
                            businessTypeValue = rawBusinessType?.name || rawBusinessType?.title || rawBusinessType?.type || "-";
                        } else if (!_.isNil(rawBusinessType)) {
                            businessTypeValue = String(rawBusinessType);
                        }

                        console.log("u ==>>>", u);
                        return {
                            id: u?.id ?? u?.user_id ?? `row-${idx}`,
                            name: u?.name || "-",
                            email: u?.email || "-",
                            phone: u?.phone || "-",
                            businessName: u?.business_name || "-",
                            businessType: businessTypeValue,
                            verified: isVerified ? "1" : "0",
                            websiteCreated: isWebsiteCreated ? "1" : "0",
                            subscriptionPlan: u?.currentPlan || "-",
                            subscriptionStartDate: startDate,
                            subscriptionExpiryDate: expiryDate,
                            subscriptionStatus: subStatusString === "active" ? "1" : "0",
                            country: u?.country || "-",
                            state: u?.state || "-",
                            city: u?.city || "-",
                            // Keep raw fields if needed in modal
                            createdAt: u?.created_at,
                            business_id:
                                typeof u?.business_type === "object"
                                    ? (u?.business_type?.id ?? u?.business_type?._id ?? u?.business_type?.code ?? u?.business_type?.name ?? "-")
                                    : (u?.business_id ?? u?.business_type ?? "-"),
                            payment_id: u?.payment_id,
                            payment_amount: u?.payment_amount,
                            payment_status: u?.payment_status,
                            payment_date: u?.payment_date,
                        };
                    });

                    setSubscriptionData(transformed);

                    const pageSize = response?.pagination?.limit
                        || response?.pagination?.defaultPageSize
                        || 25;
                    const totalPage = response?.pagination?.totalPage
                        || response?.pagination?.totalPages
                        || (response?.pagination?.totalRecords
                            ? Math.ceil(response?.pagination?.totalRecords / pageSize)
                            : undefined)
                        || 1;

                    setPagination({
                        ...response?.pagination,
                        limit: pageSize,
                        defaultPageSize: pageSize,
                        totalPage: totalPage,
                    });

                    setTimeout(() => {
                        setDataLoader(false);
                        setPageLoad(false);
                    }, 100);
                } else {
                    toast(result?.message || "Error fetching data", { type: "error" });
                    setPageLoad(false);
                    setDataLoader(false);
                }
            })
            .catch((err) => {
                toast(err?.message, { type: "error" });
                setDataLoader(false);
                setPageLoad(false);
            });
    }

    // filters removed

    // Prepare export data
    const prepareExportData = () => {
        return (subscriptionData || []).map((item, index) => ({
            "No": index + 1 + (pageNo - 1) * (pagination?.defaultPageSize || pagination?.limit || 25),
            "Name": item?.name || "-",
            "Email": item?.email || "-",
            "Phone": item?.phone || "-",
            "Business Name": item?.businessName || "-",
            "Verified": item?.verified === "1" ? "Verified" : "Non Verified",
            "Website Status": item?.websiteCreated === "1" ? "Created" : "Not Created",
            "Subscription Plan": item?.subscriptionPlan || "-",
            "Start Date": item?.subscriptionStartDate ? moment(item.subscriptionStartDate).format("DD/MM/YYYY") : "N/A",
            "Expiry Date": item?.subscriptionExpiryDate ? moment(item.subscriptionExpiryDate).format("DD/MM/YYYY") : "N/A",
            "Subscription Status": item?.subscriptionStatus === "1" ? "Active" : "Inactive",
            "Country": item?.country || "-",
            "State": item?.state || "-",
            "City": item?.city || "-",
        }));
    };

    const handleDownloadCSV = (data) => {
        const csvData = Papa.unparse(data);
        const blob = new Blob([csvData], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `subscription-details-${moment().format("YYYY-MM-DD")}.csv`;
        link.click();
        URL.revokeObjectURL(url);
        setSelectFileType("");
    };

    const handleDownloadExcel = async (data) => {
        try {
            if (!data || data.length === 0) {
                toast("No data available", { type: "error" });
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Sheet1");

            // Set columns using keys of first object
            worksheet.columns = Object.keys(data[0]).map((key) => ({
                header: key,
                key: key,
                width: 20,
            }));

            // Bold the header row
            worksheet.getRow(1).font = { bold: true };

            // Add rows
            worksheet.addRows(data);

            // Generate Excel buffer
            const buffer = await workbook.xlsx.writeBuffer();

            // Save file
            saveAs(
                new Blob([buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }),
                `subscription-details-${moment().format("YYYY-MM-DD")}.xlsx`
            );

            setSelectFileType("");
        } catch (error) {
            toast(error?.message || "Export failed", { type: "error" });
        }
    };

    // Download data from server using filters (full export)
    const getDownloadData = (type) => {
        try {
            const payload = { download: true, page: 1 };

            const hasBothDates = !!startDate && !!endDate;
            const parseNullable = (val) => (val === "" || _.isNil(val) ? null : val);

            if (hasBothDates) {
                payload.start_date = moment(startDate).format("YYYY-MM-DD");
                payload.end_date = moment(endDate).format("YYYY-MM-DD");
            } else {
                payload.subscription_plan = parseNullable(subscriptionPlan);
                payload.subscription_status = parseNullable(subscriptionStatus);
                payload.is_verified = parseInt(isVerifiedFilter);
                payload.isWebsiteCreated = parseNullable(isWebsiteCreatedFilter);
                payload.country = parseNullable(country?.trim());
                payload.state = parseNullable(stateName?.trim());
                payload.city = parseNullable(city?.trim());
            }

            getApiData(BaseSetting.endpoint.getSubScriptionDetails, "post", payload)
                .then((result) => {
                    if (result?.status) {
                        const rawList =
                            result?.data?.users ||
                            result?.data?.list ||
                            (Array.isArray(result?.data) ? result?.data : []) || [];

                        const exportRows = (rawList || []).map((u, index) => {
                            const verifiedSource = (
                                u?.verified_status ?? u?.is_verified ?? u?.verified ?? ""
                            )
                                .toString()
                                .toLowerCase()
                                .trim();
                            const isVerified =
                                verifiedSource === "1" ||
                                verifiedSource === "true" ||
                                verifiedSource === "verified" ||
                                verifiedSource === "yes" ||
                                verifiedSource === "y";

                            const websiteApprovalSource = (
                                u?.approval_status ??
                                u?.approved_status ??
                                u?.website_status ??
                                u?.websiteCreated ??
                                ""
                            )
                                .toString()
                                .toLowerCase();
                            const isWebsiteCreated = [
                                "approved",
                                "1",
                                "true",
                                "created",
                                "yes",
                            ].includes(websiteApprovalSource);

                            const planLabel = (u?.currentPlan || "-")
                                .toString()
                                .replace(/\s*plan$/i, "");

                            const start =
                                u?.subscription_start_date && u?.subscription_start_date !== "N/A"
                                    ? u.subscription_start_date
                                    : null;
                            const expiry =
                                u?.subscription_expiry_date && u?.subscription_expiry_date !== "N/A"
                                    ? u.subscription_expiry_date
                                    : null;

                            const subStatusString = (u?.subscription_status || "")
                                .toString()
                                .toLowerCase();
                            const isActive =
                                subStatusString === "active" ||
                                subStatusString === "1" ||
                                subStatusString === "true";

                            const fullName = (u?.name || `${u?.first_name || ""} ${u?.last_name || ""}`.trim() || "-");

                            return {
                                "No": index + 1,
                                "Name": fullName,
                                "Email": u?.email || "-",
                                "Phone": u?.phone || "-",
                                "Business Name": u?.business_name || "-",
                                "Verified": isVerified ? "Verified" : "Non Verified",
                                "Website Status": isWebsiteCreated ? "Created" : "Not Created",
                                "Subscription Plan": planLabel,
                                "Start Date": start ? moment(start).format("DD/MM/YYYY") : "N/A",
                                "Expiry Date": expiry ? moment(expiry).format("DD/MM/YYYY") : "N/A",
                                "Subscription Status": isActive ? "Active" : "Inactive",
                                "Country": u?.country || "-",
                                "State": u?.state || "-",
                                "City": u?.city || "-",
                            };
                        });

                        if (_.isEmpty(exportRows)) {
                            toast("No data to download", { type: "info" });
                            return;
                        }

                        if (type === "Download as CSV") {
                            handleDownloadCSV(exportRows);
                        } else {
                            handleDownloadExcel(exportRows);
                        }
                    } else {
                        toast(result?.message || "Export failed", { type: "error" });
                    }
                })
                .catch((err) => {
                    toast(err?.message, { type: "error" });
                });
        } catch (error) {
            toast(error?.message || "Export failed", { type: "error" });
        }
    };

    const handleDownload = (type) => {
        const data = prepareExportData();
        if (isEmpty(data)) {
            toast("No data to download", { type: "info" });
            return;
        }
        if (type === "Download as CSV") {
            handleDownloadCSV(data);
        } else {
            handleDownloadExcel(data);
        }
    };


    useEffect(() => {
        setPageLoad(true);
        allSubscriptionData(page, search, sortVal, sortByVal);
    }, []);

    // Helper function to get status chip color
    const getStatusChipColor = (status) => {
        switch (status) {
            case "1":
                return "success";
            case "0":
                return "error";
            default:
                return "default";
        }
    };

    // Helper function to get subscription plan chip color
    const getPlanChipColor = (plan) => {
        switch (plan?.toLowerCase()) {
            case "premium":
                return "primary";
            case "gold":
                return "warning";
            case "free":
                return "default";
            default:
                return "default";
        }
    };
    const changeSubscriptionStatus = (row) => {
        console.log("row ==>>>", row);

        try {
            const currentStatus = row?.subscriptionStatus === "1" ? "1" : "0";
            const nextStatus = currentStatus === "1" ? "0" : "1";

            // Optimistic UI update
            setSubscriptionData((prev) =>
                (prev || []).map((r) =>
                    r.id === row.id ? { ...r, subscriptionStatus: nextStatus } : r
                )
            );

            const endpoint = BaseSetting.endpoint.changeSubscriptionStatus;

            const payload = {
                user_id: row?.id,
                subscription_status: nextStatus,  // "1" or "0"
            };

            getApiData(endpoint, "post", payload)
                .then((result) => {
                    if (result?.status) {
                        toast(result?.message || "Status updated", { type: "success" });

                        // Refetch latest data for consistency
                        setDataLoader(true);
                        setPageLoad(true);
                        allSubscriptionData(page, search, sortVal, sortByVal);
                    } else {
                        // Revert optimistic update on failure
                        setSubscriptionData((prev) =>
                            (prev || []).map((r) =>
                                r.id === row.id ? { ...r, subscriptionStatus: currentStatus } : r
                            )
                        );
                        toast(result?.message || "Failed to update status", { type: "error" });
                    }
                })
                .catch((err) => {
                    setSubscriptionData((prev) =>
                        (prev || []).map((r) =>
                            r.id === row.id ? { ...r, subscriptionStatus: currentStatus } : r
                        )
                    );
                    toast(err?.message || "Failed to update status", { type: "error" });
                });
        } catch (error) {
            toast(error?.message || "Failed to update status", { type: "error" });
        }
    };


    const subscriptionColumns = [
        {
            field: "id",
            headerName: "NO.",
            flex: 0.2,
            minWidth: 70,
            headerAlign: "center",
            align: "center",
            sortable: false,
            renderCell: (params) => {
                const newStartIndex = (pageNo - 1) * pagination?.defaultPageSize + 1;
                subscriptionData.map((data, i) => {
                    data.serialNumber = i + newStartIndex;
                });
                return (
                    <Typography style={{ fontFamily: FontFamily.SemiBold }}>
                        {params?.row?.serialNumber}
                    </Typography>
                );
            },
        },
        {
            field: "actions",
            headerName: "ACTIONS",
            flex: 0.6,
            headerAlign: "center",
            minWidth: 100,
            align: "center",
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Tooltip title="View details" placement="top" arrow>
                        <Button onClick={() => openEditModal(params?.row)}>
                            <Visibility style={{ fontSize: 20 }} />
                        </Button>
                    </Tooltip>
                );
            },
        },
        {
            field: "name",
            headerName: "NAME",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            minWidth: 120,
        },
        {
            field: "email",
            headerName: "EMAIL",
            flex: 2,
            headerAlign: "center",
            align: "center",
            minWidth: 180,
        },
        {
            field: "phone",
            headerName: "PHONE",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            minWidth: 130,
        },
        {
            field: "businessName",
            headerName: "BUSINESS NAME",
            flex: 2,
            headerAlign: "center",
            align: "center",
            minWidth: 150,
        },

        {
            field: "verified",
            headerName: "VERIFIED",
            flex: 1,
            headerAlign: "center",
            align: "center",
            minWidth: 100,
            renderCell: (params) => {
                return (
                    <Chip
                        label={params?.row?.verified === "1" ? "Verified" : "Not Verified"}
                        color={getStatusChipColor(params?.row?.verified)}
                        size="small"
                    />
                );
            },
        },
        {
            field: "websiteCreated",
            headerName: "WEBSITE STATUS",
            flex: 1.2,
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <Chip
                        label={params?.row?.websiteCreated === "1" ? "Created" : "Not Created"}
                        color={getStatusChipColor(params?.row?.websiteCreated)}
                        size="small"
                    />
                );
            },
        },
        {
            field: "subscriptionPlan",
            headerName: "SUBSCRIPTION PLAN",
            flex: 1.5,
            headerAlign: "center",
            align: "center",
            minWidth: 140,
            renderCell: (params) => {
                return (
                    <Chip
                        label={params?.row?.subscriptionPlan}
                        color={getPlanChipColor(params?.row?.subscriptionPlan)}
                        size="small"
                    />
                );
            },
        },
        {
            field: "country",
            headerName: "COUNTRY",
            flex: 1,
            headerAlign: "center",
            align: "center",
            minWidth: 120,
        },
        {
            field: "state",
            headerName: "STATE",
            flex: 1,
            headerAlign: "center",
            align: "center",
            minWidth: 120,
        },
        {
            field: "city",
            headerName: "CITY",
            flex: 1,
            headerAlign: "center",
            align: "center",
            minWidth: 120,
        },
        {
            field: "businessType",
            headerName: "BUSINESS TYPE",
            flex: 1.2,
            headerAlign: "center",
            align: "center",
            minWidth: 140,
        },
        {
            field: "subscriptionStartDate",
            headerName: "START DATE",
            flex: 1.2,
            headerAlign: "center",
            align: "center",
            minWidth: 110,
            renderCell: (params) => {
                const val = params?.row?.subscriptionStartDate;
                return val ? moment(val).format("DD/MM/YYYY") : "N/A";
            },
        },
        {
            field: "subscriptionExpiryDate",
            headerName: "EXPIRY DATE",
            flex: 1.2,
            headerAlign: "center",
            align: "center",
            minWidth: 110,
            renderCell: (params) => {
                const val = params?.row?.subscriptionExpiryDate;
                return val ? moment(val).format("DD/MM/YYYY") : "N/A";
            },
        },
        {
            field: "subscriptionStatus",
            headerName: "SUBSCRIPTION STATUS",
            flex: 1,
            headerAlign: "center",
            align: "center",
            minWidth: 160,
            filterable: false,
            renderCell: (params) => {
                const isActive = params?.row?.subscriptionStatus === "1";
                return (
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <Switch
                            checked={isActive}
                            onChange={() => changeSubscriptionStatus(params?.row)}
                            color={isActive ? "success" : "default"}
                        />
                        <Typography style={{ fontFamily: FontFamily.SemiBold }}>
                            {isActive ? "Active" : "Inactive"}
                        </Typography>
                    </div>
                );
            },
        },
        // removed combined location column

    ];

    return (
        <Grid container>
            <MiniDrawer
                header="Subscription Details"
                children={
                    <>
                        <Grid container justifyContent={"space-between"}>
                            <div style={{ display: "flex", gap: "10px" }}>
                                <CSelect
                                    placeholder="Choose file format for download"
                                    value={selectFileType}
                                    data={downloadOptions}
                                    onSelect={(val) => {
                                        setSelectFileType(val);
                                        getDownloadData(val);
                                    }}
                                />
                            </div>
                        </Grid>
                        {/* filters removed */}
                        {/* Filters */}
                        <Grid container spacing={2} mt={"20px"} alignItems={"flex-end"}>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="plan-label">Plan</InputLabel>
                                    <Select
                                        labelId="plan-label"
                                        label="Plan"
                                        value={subscriptionPlan}
                                        onChange={(e) => setSubscriptionPlan(e.target.value)}
                                    >
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="Free">Free</MenuItem>
                                        <MenuItem value="Gold">Gold</MenuItem>
                                        <MenuItem value="Diamond">Diamond</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="status-label">Status</InputLabel>
                                    <Select
                                        labelId="status-label"
                                        label="Status"
                                        value={subscriptionStatus}
                                        onChange={(e) => setSubscriptionStatus(e.target.value)}
                                    >
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="1">Active</MenuItem>
                                        <MenuItem value="2">Expired</MenuItem>
                                        <MenuItem value="0">Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="verified-label">Verified</InputLabel>
                                    <Select
                                        labelId="verified-label"
                                        label="Verified"
                                        value={isVerifiedFilter}
                                        onChange={(e) => setIsVerifiedFilter(e.target.value)}
                                    >
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="1">Verified</MenuItem>
                                        <MenuItem value="0">Not Verified</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="website-label">Website</InputLabel>
                                    <Select
                                        labelId="website-label"
                                        label="Website"
                                        value={isWebsiteCreatedFilter}
                                        onChange={(e) => setIsWebsiteCreatedFilter(e.target.value)}
                                    >
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="1">Created</MenuItem>
                                        <MenuItem value="0">Not Created</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="date"
                                    label="Start Date"
                                    InputLabelProps={{ shrink: true }}
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="date"
                                    label="End Date"
                                    InputLabelProps={{ shrink: true }}
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Country"
                                    value={country}
                                    onChange={(e) => setCountry(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="State"
                                    value={stateName}
                                    onChange={(e) => setStateName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="City"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    onClick={() => {
                                        setSubscriptionPlan("");
                                        setSubscriptionStatus("");
                                        setIsVerifiedFilter("");
                                        setIsWebsiteCreatedFilter("");
                                        setStartDate("");
                                        setEndDate("");
                                        setCountry("");
                                        setStateName("");
                                        setCity("");
                                    }}
                                >
                                    Clear
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container mt={"20px"}>
                            {pageLoad ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%",
                                        height: "50vh",
                                    }}
                                >
                                    <CircularProgress
                                        style={{ color: BaseColor.primary }}
                                        size={30}
                                    />
                                </div>
                            ) : (
                                <DataGrid
                                    sortModel={
                                        sortByVal === "asc" || sortByVal === "desc"
                                            ? [
                                                {
                                                    field: sortVal,
                                                    sort: sortByVal,
                                                },
                                            ]
                                            : []
                                    }
                                    onSortModelChange={(model) => {
                                        setDataLoader(true);
                                        if (!_.isEmpty(model)) {
                                            setHeaderParams(
                                                isPage,
                                                search,
                                                model[0]?.field,
                                                model[0].sort,
                                                downloadId
                                            );
                                            allSubscriptionData(
                                                page,
                                                search,
                                                model[0]?.field,
                                                model[0].sort,
                                                downloadId
                                            );
                                        } else {
                                            setHeaderParams(isPage, search, "", "", downloadId);
                                            allSubscriptionData(page, search);
                                        }
                                    }}
                                    disableColumnFilter
                                    disableColumnSelector
                                    rows={subscriptionData}
                                    columns={subscriptionColumns}
                                    disableColumnMenu
                                    hideFooter={false}
                                    hideFooterPagination
                                    loading={dataLoader}
                                    sortingMode="server"
                                    apiRef={getDataGridApi}
                                    disableDensitySelector
                                    checkboxSelection={false}
                                    paginationMode="server"

                                    showCellVerticalBorder={true}
                                    disableRowSelectionOnClick
                                    showColumnVerticalBorder={true}
                                    disableSelectionOnClick
                                    autoHeight={true}
                                    getRowHeight={() => "auto"}
                                    slots={{ toolbar: GridToolbar }}
                                    initialState={{
                                        filter: {
                                            filterModel: {
                                                items: [],
                                                quickFilterValues: [searchVal],
                                            },
                                        },
                                    }}
                                    sx={{
                                        "& .MuiInputBase-root button svg.MuiSvgIcon-fontSizeSmall":
                                        {
                                            display: "none",
                                            backgroundColor: "red",
                                        },
                                        "& .css-dwjt6a-MuiButtonBase-root-MuiIconButton-root": {
                                            display: "none",
                                        },
                                        "&:hover .css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb":
                                        {
                                            background: "#674188",
                                        },
                                        ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar":
                                        {
                                            width: "1px",
                                            height: "4px",
                                        },
                                        ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-track":
                                        {
                                            background: "#F7EFE5",
                                        },
                                        ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb":
                                        {
                                            background: "rgba(103, 65, 136, 0.5)",
                                            borderRadius: "10px",
                                        },
                                    }}
                                    slotProps={{
                                        toolbar: {
                                            printOptions: { disableToolbarButton: true },
                                            csvOptions: { disableToolbarButton: true },
                                            showQuickFilter: true,
                                            onChange: (e) => {
                                                setDataLoader(true);
                                                setSearchVal(e.target.value?.toLowerCase());
                                                setHeaderParams(
                                                    1,
                                                    e?.target?.value?.toLowerCase(),
                                                    sortVal,
                                                    sortByVal,
                                                    downloadId
                                                );
                                                if (searchRef.current) clearTimeout(searchRef.current);
                                                searchRef.current = setTimeout(() => {
                                                    allSubscriptionData(
                                                        1,
                                                        e?.target?.value?.toLowerCase(),
                                                        sortVal,
                                                        sortByVal
                                                    );
                                                }, 800);
                                            },
                                        },
                                    }}
                                />
                            )}
                        </Grid>
                        {!isEmpty(subscriptionData) && isArray(subscriptionData) && (
                            <div
                                style={{
                                    marginTop: "20px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <Pagination
                                    count={pagination?.totalPage}
                                    page={page}
                                    siblingCount={2}
                                    onChange={(e, value) => {
                                        allSubscriptionData(value);
                                        setPageLoad(true);
                                        setPageNo(value);
                                        setHeaderParams(
                                            value,
                                            search,
                                            sortVal,
                                            sortByVal
                                        );
                                        allSubscriptionData(value, search, sortVal, sortByVal);
                                    }}
                                    sx={{ display: pageLoad ? "none" : "block" }}
                                />
                            </div>
                        )}


                        <CModal
                            visible={modalOpen}
                            onClose={() => {
                                handleClose();
                                setSelectedUser(null);

                            }}
                            title={"Subscription Details"}
                            style={{ width: "60%" }}
                            children={
                                <Grid container item xs={12} padding={"30px"} gap={2}>
                                    {selectedUser && (
                                        <>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography variant="h6" gutterBottom>
                                                        Personal Information
                                                    </Typography>
                                                    <Typography><strong>Name:</strong> {selectedUser.name}</Typography>
                                                    <Typography><strong>Email:</strong> {selectedUser.email}</Typography>
                                                    <Typography><strong>Phone:</strong> {selectedUser.phone}</Typography>
                                                    <Typography><strong>Verified:</strong> {selectedUser.verified === "1" ? "Yes" : "No"}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="h6" gutterBottom>
                                                        Business Information
                                                    </Typography>
                                                    <Typography><strong>Business Name:</strong> {selectedUser.businessName}</Typography>

                                                    <Typography><strong>Website Created:</strong> {selectedUser.websiteCreated === "1" ? "Yes" : "No"}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="h6" gutterBottom>
                                                        Subscription Details
                                                    </Typography>
                                                    <Typography><strong>Plan:</strong> {selectedUser.subscriptionPlan}</Typography>
                                                    <Typography><strong>Start Date:</strong> {moment(selectedUser.subscriptionStartDate).format("DD/MM/YYYY")}</Typography>
                                                    <Typography><strong>Expiry Date:</strong> {moment(selectedUser.subscriptionExpiryDate).format("DD/MM/YYYY")}</Typography>
                                                    <Typography><strong>Status:</strong> {selectedUser.subscriptionStatus === "1" ? "Active" : "Inactive"}</Typography>
                                                    <Typography><strong>Renewal Policy:</strong> {selectedUser.renewalPolicy === "auto" ? "Automatic" : "Manual"}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography variant="h6" gutterBottom>
                                                        Location
                                                    </Typography>
                                                    <Typography><strong>Country:</strong> {selectedUser.country}</Typography>
                                                    <Typography><strong>State:</strong> {selectedUser.state}</Typography>
                                                    <Typography><strong>City:</strong> {selectedUser.city}</Typography>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            }
                        />
                    </>
                }
            />
        </Grid>
    );
};

export default SubscriptionDetails;
